export default [
    {
        company: "CAAT Pension Plan",
        site: "https://www.caatpension.on.ca/en/",
        img: "img/organizations_logos/caat.png",
        location: "Toronto, Ontario",
        position: "Senior Web Developer",
        duration: "April 2024 &#8211 Present",
        description: [
            'Working in the software development team at CAAT Pension Plan',
        ],
        display: true,
    },
    {
        company: "CAAT Pension Plan",
        site: "https://www.caatpension.on.ca/en/",
        img: "img/organizations_logos/caat.png",
        location: "Toronto, Ontario",
        position: "Web Developer",
        duration: "May 2021 &#8211 March 2024",
        description: [
            'Working in the software development team at CAAT Pension Plan',
        ],
        display: true,
    },
    {
        company: "CAAT Pension Plan",
        site: "https://www.caatpension.on.ca/en/",
        img: "img/organizations_logos/caat.png",
        location: "Toronto, Ontario",
        position: "Student (Software Development)",
        duration: "May &#8211 August 2020",
        description: [
            'Worked in an Agile (SCRUM) team where I implemented functionalities according to business requirements while meeting sprint deadlines ',
            'Implemented functionalities for a .NET Core server that interacts with a SQL database',
            'Created Unit Tests for applications with the xUnit framework and Moq',
            'Added fixes and enhancements to existing internal applications',
        ],
        display: true,
    },
    {
        company: "Teranet",
        site: "https://www.teranet.ca/",
        img: "img/organizations_logos/teranet.png",
        location: "Toronto, Ontario",
        position: "Student (Enterprise Architecture)",
        duration: "May &#8211 August 2019",
        description: [
            'Conducted research and analysis for the Technology Architecture Group',
            'Designed new SharePoint site for Architecture Team',
            'Participated in the redesigning and updating of Architecture process flows',
        ],
        display: true,
    },
    {
        company: "Teranet",
        site: "https://www.teranet.ca/",
        img: "img/organizations_logos/teranet.png",
        location: "Toronto, Ontario",
        position: "Student (Enterprise Architecture)",
        duration: "May &#8211 August 2018",
        description: [
            'Conducted research and analysis for the Technology Architecture Group',
            'Performed testing and evaluation of emerging, opensource, off-shelf and in-house applications',
            'Participated in Proof of Technology (POT) by creating manual for application(s) being tested',
        ],
        display: true,
    },
    {
        company: "JMB IT SOLUTIONS",
        img: "img/organizations_logos/JMB.png",
        position: "IT Consultant & Trainer",
        duration: "June 2016 &#8211 August 2018",
        description: [
            'Trained customers on Windows/Android/iPhone, Email, Social Media',
            'Provide technical expertise in troubleshooting to resolve IT issues',            
            'Set up cloud based solutions for customer’s data and media storage',
            'Set up wired/wireless networks for residential use'
        ],
        display: false,
    },
    {
        company: "LONGO'S",
        img: "img/organizations_logos/longos.png",
        position: "Cashier",
        duration: "June 2016 &#8211 August 2017",
        description: [
            'Received recognition from customers for outstanding customer service',
            'Trained new employees on cashier duties',            
            'Consistently improved customer satisfaction by resolving inquiries and concerns',
        ],
        display: false,
    },
]